import * as React from "react"
import {Label} from "semantic-ui-react"

interface Props {
  nickname: string
  pointing: false | "right"
}

export function PlaceNicknameLabel({nickname, pointing}: Props) {
  return (
    <Label style={{marginBottom: "2px"}} color="teal" pointing={pointing}>
      {nickname}
    </Label>
  )
}



// WEBPACK FOOTER //
// ./src/components/PlaceNicknameLabel.tsx